export default __webpack_public_path__ + "static/media/sala-de-maquinas.899604b5.jpg";